import { render, staticRenderFns } from "./UdmGenerator.vue?vue&type=template&id=e59927fa"
import script from "./UdmGenerator.vue?vue&type=script&lang=js"
export * from "./UdmGenerator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports